import { useState } from "react";
import { FileDown, Search } from "lucide-react";
import ResourcePage from "../../components/ResourcePage";
import PdfViewer from "../../components/PdfViewer";

const reportTypes = [
  { value: "clientes", label: "Clientes" },
  { value: "reservas", label: "Reservas / Check-in" },
  { value: "faturas", label: "Faturas e documentos" },
  { value: "avisos-cobranca", label: "Avisos de cobranca" },
  { value: "recibos", label: "Recibos" },
  { value: "despesas", label: "Despesas" },
];

const RelatoriosPdf = () => {
  const [filters, setFilters] = useState({
    tipo: "faturas",
    formato: "A4",
    inicio: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().slice(0, 10),
    fim: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).toISOString().slice(0, 10),
  });
  const [viewer, setViewer] = useState(null);

  const update = (field, value) => {
    setFilters((current) => ({ ...current, [field]: value }));
  };

  const preview = () => {
    const params = new URLSearchParams({
      formato: filters.formato,
      inicio: filters.inicio,
      fim: filters.fim,
    });
    setViewer({
      title: reportTypes.find((item) => item.value === filters.tipo)?.label || "Relatorio",
      path: `/pdf/relatorios/${filters.tipo}?${params.toString()}`,
      filename: `relatorio-${filters.tipo}-${filters.formato}.pdf`,
    });
  };

  return (
    <ResourcePage title="Relatorios PDF" breadcrumb={["Relatorios", "PDF"]}>
      <div className="card app-card bg-white">
        <div className="card-body">
          <div className="row align-items-end g-3">
            <div className="col-md-3">
              <label className="form-label" htmlFor="tipo_relatorio">Relatorio</label>
              <select className="form-select" id="tipo_relatorio" value={filters.tipo} onChange={(event) => update("tipo", event.target.value)}>
                {reportTypes.map((item) => <option key={item.value} value={item.value}>{item.label}</option>)}
              </select>
            </div>
            <div className="col-md-2">
              <label className="form-label" htmlFor="formato_relatorio">Formato</label>
              <select className="form-select" id="formato_relatorio" value={filters.formato} onChange={(event) => update("formato", event.target.value)}>
                <option value="A4">A4</option>
                <option value="A5">A5</option>
                <option value="TICKET">Ticket</option>
              </select>
            </div>
            <div className="col-md-2">
              <label className="form-label" htmlFor="inicio_relatorio">Inicio</label>
              <input className="form-control" id="inicio_relatorio" type="date" value={filters.inicio} onChange={(event) => update("inicio", event.target.value)} />
            </div>
            <div className="col-md-2">
              <label className="form-label" htmlFor="fim_relatorio">Fim</label>
              <input className="form-control" id="fim_relatorio" type="date" value={filters.fim} onChange={(event) => update("fim", event.target.value)} />
            </div>
            <div className="col-md-auto d-flex gap-2">
              <button className="btn btn-primary d-inline-flex align-items-center gap-1" type="button" onClick={preview}>
                <Search size={16} />
                Previsualizar
              </button>
              <button className="btn btn-light d-inline-flex align-items-center gap-1" type="button" onClick={preview}>
                <FileDown size={16} />
                PDF
              </button>
            </div>
          </div>
        </div>
      </div>

      <PdfViewer
        title={viewer?.title}
        path={viewer?.path}
        filename={viewer?.filename}
        onClose={() => setViewer(null)}
      />
    </ResourcePage>
  );
};

export default RelatoriosPdf;
